import { Input } from "@/shared/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/ui/select";
import { Label } from "@/shared/ui/label";
import { Card, CardContent } from "@/shared/ui/card";
import { useTranslation } from "@/shared/i18n";

interface CategoryBasicInfoProps {
    formData: {
        name?: string;
        type?: string;
    };
    setFormData: (data: { name: string; type: string }) => void;
}

export const CategoryBasicInfo = ({ formData, setFormData }: CategoryBasicInfoProps) => {
    const { t } = useTranslation('categories');
    return (
        <Card className="bg-white/[0.03] border-white/[0.06]">
            <CardContent className="pt-6">
                <div className="space-y-6">
                    <h3 className="text-lg font-semibold text-white">{t('basicInfo')}</h3>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                            <Label htmlFor="name" className="text-white">{t('nameLabel')}</Label>
                            <Input
                                id="name"
                                value={formData.name || ""}
                                onChange={(e) => setFormData({ name: e.target.value, type: formData.type || "" })}
                                placeholder={t('namePlaceholder')}
                                className="bg-[#222222] border-[#333333] text-white placeholder:text-gray-400"
                                required
                            />
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="type" className="text-white">{t('typeLabel')}</Label>
                            <Select value={formData.type || ""} onValueChange={(value) => setFormData({ name: formData.name || "", type: value })}>
                                <SelectTrigger className="bg-[#222222] border-[#333333] text-white">
                                    <SelectValue placeholder={t('selectType')} />
                                </SelectTrigger>
                                <SelectContent className="bg-[#222222] border-[#333333]">
                                    <SelectItem value="PRESET" className="text-white hover:bg-[#333333]">{t('preset')}</SelectItem>
                                    <SelectItem value="LEARNING" className="text-white hover:bg-[#333333]">{t('learning')}</SelectItem>
                                    <SelectItem value="TEMPLATE" className="text-white hover:bg-[#333333]">{t('template')}</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};